import ServiceBase from '@/services/ServiceBase';

const resource = 'api/v1/type-identification';

class IdentificationTypeService extends ServiceBase {
  constructor() {
    super({ resource });
  }
}

export default IdentificationTypeService;



// WEBPACK FOOTER //
// ./src/services/IdentificationTypeService.js